import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Outlet, Navigate } from 'react-router-dom';
import { api, pesan, Token, host, compressImageBase64, resizeImageBase64, submitForm, isJson } from './Modul';
import { requestForToken, onMessageListener } from './firebase';
import Logo from './assets/img/logo.png';
import LogoPanjang from './assets/img/logopanjang.png';
import Profile from './assets/img/profile.png';
import './App.css';
import './Login.css';

// PAGE
const Dashboard = lazy(() => import('./page/Dashboard'));;
const MenuPelanggan = lazy(() => import('./page/MenuPelanggan'));
const MenuDatabase = lazy(() => import('./page/MenuDatabase'));
const MenuMenu = lazy(() => import('./page/MenuMenu'));
const MenuAdmin = lazy(() => import('./page/MenuAdmin'));
const MenuReqFitur = lazy(() => import('./page/MenuReqFitur'));
const MenuSystem = lazy(() => import('./page/MenuSystem'));
const MenuUser = lazy(() => import('./page/MenuUser'));
const MenuChat = lazy(() => import('./page/MenuChat'));
const MenuFileManager = lazy(() => import('./page/MenuFileManager'));
const MenuAffiliate = lazy(() => import('./page/MenuAffiliate'));
const Login = lazy(() => import('./page/Login'));

function App() {
  class Main extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        Menu: [],
        Group: [],
        CurePage: [],
        NamaLokasi: "Pusat",
        NamaUser: "Heru Prasetia",
        divSetting: [],
        detailSetting: [],
        clsLoading: "fas fa-save",
        btnSubmit: false,
        iconTheme: "fas fa-moon",
        show: false,
        notification: { title: '', body: '' },
        tokenFound: false
      };
    }

    async componentDidMount() {
      if (!localStorage.getItem("TokenFirebase")) requestForToken(this.setTokenFound);
      let sql = await api("data", { act: "data menu" });
      if (sql.status == "sukses") {
        let Menu = [], Group = [
          { Nama: "Konten", Icon: "fas fa-images", Posisi: "konten", Active: false },
          { Nama: "Master", Icon: "fas fa-th-list", Posisi: "master", Active: false },
          { Nama: "Artikel", Icon: "fas fa-newspaper", Posisi: "artikel", Active: false },
        ];
        for (let menu of sql.data) {
          Menu.push(menu);
          for (let gg in Group) if (Group[gg].Posisi == menu.Posisi) Group[gg].Active = true;
        }
        let ColorTheme = localStorage.getItem("ColorTheme") || "dark";
        if (ColorTheme == "dark") {
          document.body.classList.add('dark-theme');
        } else {
          document.body.classList.remove('dark-theme');
          document.body.classList.add('light-theme');
        }

        if (ColorTheme == "dark") {
          document.getElementById("theme-link").href = "https://cdn.jsdelivr.net/npm/devextreme@23.2/dist/css/dx.darkviolet.css";
        } else {
          document.getElementById("theme-link").href = "https://cdn.jsdelivr.net/npm/devextreme@23.2/dist/css/dx.greenmist.css";
        }
        this.setState({ Menu: Menu, Group: Group, iconTheme: ColorTheme == "light" ? "fas fa-moon" : "fas fa-sun" });
        if (window.location.hostname != "localhost") console.clear();
      } else {
        this.handleLogout();
      }
    }

    setTokenFound = async (tokenFound, token) => {
      if (tokenFound) {
        localStorage.setItem("TokenFirebase", token);
        await api("user_api", { act: "set token", TokenFireBase: token }, true);
        this.setState({ tokenFound });
      }
    };

    handleColaps() {
      document.getElementById("sidebar").style.display = "block";
      document.getElementById("sidebar").classList.toggle("hide");
    }

    handlePilihMenu(Menu, Title) {
      let clsMenu = document.getElementsByClassName("menu");
      for (let i = 0; i < clsMenu.length; i++) clsMenu[i].classList.remove("active");
      document.getElementById('menu' + Menu).classList.add("active");
      document.title = Title;
    }

    handleLogout() {
      localStorage.clear();
      window.location.reload();
    }

    handleChangeTheme() {
      let ColorTheme = localStorage.getItem("ColorTheme") || "dark";
      if (ColorTheme == "light") {
        localStorage.setItem("ColorTheme", "dark");
        document.getElementById("theme-link").href = "https://cdn.jsdelivr.net/npm/devextreme@23.2/dist/css/dx.darkviolet.css";
        document.body.classList.add('dark-theme');
        document.body.classList.remove('light-theme');
        this.setState({ iconTheme: "fas fa-sun" });
      } else {
        localStorage.setItem("ColorTheme", "light");
        document.getElementById("theme-link").href = "https://cdn.jsdelivr.net/npm/devextreme@23.2/dist/css/dx.greenmist.css";
        document.body.classList.remove('dark-theme');
        document.body.classList.add('light-theme');
        this.setState({ iconTheme: "fas fa-moon" });
      }
    }

    handleCariMenu(val) {
      if (val !== "") {

      } else {
        let Menu = this.state.Menu, Group = [
          { Nama: "Konten", Icon: "fas fa-images", Posisi: "konten", Active: false },
          { Nama: "Master", Icon: "fas fa-th-list", Posisi: "master", Active: false }
        ];
        for (let menu of Menu) {
          Menu.push(menu);
          for (let gg in Group) if (Group[gg].Posisi == menu.Posisi) Group[gg].Active = true;
        }
      }
    }

    render() {
      return (
        <Router>
          <div className="wrapper">
            <nav id="sidebar" className="sidebar">
              <div className="sidebar-header cursor">
                <img src={LogoPanjang} width="90%" className="logo-panjang" />
                <img src={Logo} style={{ width: "50px", height: "50px" }} className="logo" />
              </div>
              <div className="transbox">
                <input type="search" name="qMenu" id="qMenu" className="form-control form-control-sm" placeholder="[F2] Cari Menu . . ."
                  onFocus={(e) => e.target.select()} autoComplete="off" />
                <ul className="list-unstyled components" id="ulMenu">
                  {
                    this.state.Menu.map((li, i) => {
                      if (li.Posisi == "root") {
                        return (
                          <li className="menu" id={"menu" + li.Path} key={li.Path} onClick={() => this.handlePilihMenu(li.Path, li.Nama)}>
                            <Link to={`/${li.Path}`}>
                              <i className={li.Icon}></i> <span className="nama-menu">{li.Nama}</span>
                            </Link>
                          </li>
                        )
                      }
                    })
                  }
                  {
                    this.state.Group.map((ul, i) => {
                      if (ul.Posisi != "root") {
                        let Menus = [];
                        for (let dd of this.state.Menu) if (dd.Posisi == ul.Posisi) Menus.push(dd);
                        if (Menus.length > 0) {
                          return (
                            <li key={i}>
                              <a href={`#GroupMenu${ul.Posisi}`} data-bs-toggle="collapse" aria-expanded="false" className="dropdown-toggle" key={ul.Posisi}>
                                <i className={ul.Icon}></i>
                                <span className="nama-menu">{ul.Nama}</span>
                              </a>
                              <ul className="collapse list-unstyled" id={`GroupMenu${ul.Posisi}`}>
                                {
                                  Menus.map((li, ii) => {
                                    return (
                                      <li className="menu" id={"menu" + li.Path} key={li.Path} onClick={() => this.handlePilihMenu(li.Path, li.Nama)}>
                                        <Link to={`/${li.Path}`}>
                                          {li.Nama}
                                        </Link>
                                      </li>)
                                  })
                                }
                              </ul>
                            </li>
                          )
                        }
                      }
                    })
                  }
                </ul>
              </div>
            </nav >
            <div id="content">
              <nav className="navbar">
                <div className="container-fluid d-flex nav-container">
                  <button type="button" id="sidebarCollapse" className="btn btn-sm nav-menu" onClick={() => this.handleColaps()}> <i className="fas fa-bars"></i> </button>
                  <div className="d-flex justify-content-end align-items-center nav-menu-items">
                    <button type="button" className="btn align-items-center nav-menu" style={{ position: "relative" }} onClick={() => this.handleChangeTheme()}>
                      <i className={this.state.iconTheme}></i>
                    </button>
                    <div className="dropdown ">
                      <button className="dropdown-toggle nav-profile" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <div className="nav-profile-photo">
                          <img src={Profile} />
                        </div>
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end shadow-lg dropdown-menu-dark" style={{ minWidth: "14rem", fontSize: "0.9rem", maxHeight: "440px", overflowY: "auto" }}>
                        <li className="dropdown-item">
                          <a><b>Login Sebagai : </b></a>
                          <br></br>
                          <p className="mt-2 d-flex align-items-end">
                            <i className="fas fa-user"></i>
                            <span id='spanUserName'>{this.state.NamaUser}</span>
                          </p>
                        </li>
                        <li>
                          <hr className="dropdown-divider"></hr>
                        </li>
                        <li><span onClick={() => this.handleLogout()} className="dropdown-item text-center"><i className="fas fa-logout"></i> Keluar</span></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>
              <div id="tampil">
                <Suspense fallback={<div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                  {/* <div className="spinner-border text-success" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div> */}
                  <img src={require('./assets/img/loading-upload.gif')} />
                </div>}>
                  <Routes>
                    <Route path="/" element={<Dashboard page="Home" />} />
                    <Route path="/dashboard" element={<Dashboard page="Home" />} />
                    <Route path="/manage-bussiness" element={<MenuPelanggan />} />
                    <Route path="/manage-db" element={<MenuDatabase />} />
                    <Route path="/manage-menu" element={<MenuMenu />} />
                    <Route path="/manage-admin" element={<MenuAdmin />} />
                    <Route path="/reqfitur" element={<MenuReqFitur />} />
                    <Route path="/system" element={<MenuSystem />} />
                    <Route path="/manage-user" element={<MenuUser />} />
                    <Route path="/chat" element={<MenuChat />} />
                    <Route path="/filemanager" element={<MenuFileManager />} />
                    <Route path="/affiliate" element={<MenuAffiliate />} />
                  </Routes>
                </Suspense>
              </div>
              <div id="divPesan"></div>
            </div>
          </div>
        </Router >
      )
    }
  }

  if (Token) {
    return <Main />
  } else {
    return <Login />
  }
}

export default App;
